export const SITEMAP = 'sitemap';
